import ContentType from '@/ecm/models/contentType/ContentType'

export default class ContentTypeImport {
    constructor (dto) {
        this.contentType = null
        this.roles = []
        if (dto) {
            this.contentType = new ContentType(dto)
        }
    }

    toDto () {
        return {
            ContentTypeStr: this.contentType.toDto().ContentTypeStr,
            ContentType: null,
            RolesNames: this.roles,
        }
    }
}
